__turbopack_context__.v({
  "className": "noto_sans_kr_e2153cdd-module__r-EoEW__className",
});
